import React, { createContext, useState, useContext, useEffect } from "react";
import { loginApi, logoutApi, fetchUserData } from "../Services/authService";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initializeUser = async () => {
      try {
        const fullUserData = await fetchUserData();
        setUser(fullUserData.user);
        console.log("Initialized user with full data:", fullUserData.user);
      } catch (err) {
        console.error("No active session:", err);
        setUser(null);
      }
      setLoading(false);
    };

    initializeUser();
  }, []);

  const loginUser = async (username, password, onSuccess) => {
    try {
      await loginApi(username, password);
      setError(null);

      const fullUserData = await fetchUserData();
      setUser(fullUserData.user);

      if (onSuccess) onSuccess(fullUserData.user);
    } catch (err) {
      console.error("Login failed:", err);
      setError(err.message);
      throw err;
    }
  };

  const logoutUser = async () => {
    await logoutApi();
    localStorage.removeItem("user");
    localStorage.removeItem("isAdmin");
    setUser(null);
    console.log("User logged out");
  };

  const refreshUserData = async () => {
    try {
      const data = await fetchUserData();
      setUser(data.user);
      console.log("User data refreshed:", data.user);
    } catch (err) {
      console.error("Failed to refresh user data:", err);
    }
  };

  return (
    <UserContext.Provider
      value={{ user, loginUser, logoutUser, refreshUserData, loading, error }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
